import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { Box, Flex, Copy } from '@elparking/components'
import VehicleTypeFilter from 'commons/js/components/VehicleTypeFilter'
import CarTypeSelector from './sections/CarTypeSelector'
import { RENTAL_CAR_VEHICLE_TYPE_CAR } from 'commons/js/constants'
import { FormattedMessage } from 'react-intl'

const VehicleFilterBox = ({
    filters,
    setFilters,
    isLoading,
    isModal,
}) => {
    const [vehicleTypeFilter, setVehicleTypeFilter] = useState((filters && filters.vehicleType))
    const [categoryListFilter, setCategoryListFilter] = useState((filters && filters.categoryList))

    const haveFiltersChanged = () => vehicleTypeFilter !== filters.vehicleType || categoryListFilter !== filters.categoryList
    useEffect(() => {
        if (haveFiltersChanged()) {
            setFilters({
                ...filters,
                vehicleType: vehicleTypeFilter,
                categoryList: categoryListFilter,
            })
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [setFilters, vehicleTypeFilter, categoryListFilter])
    return (
        <Flex width='100%' flexDirection='column'>
            <Box marginBottom='1em' width='100%'>
                {isModal && <Copy marginBottom='0.5em' fontSize='xLarge' fontColor='accent_dark' fontWeight='bold'><FormattedMessage defaultMessage='Categorías' /></Copy>}
                <VehicleTypeFilter isModal={isModal} vehicleType={vehicleTypeFilter} setVehicleType={setVehicleTypeFilter} isLoading={isLoading}/>
            </Box>
            {vehicleTypeFilter === RENTAL_CAR_VEHICLE_TYPE_CAR && <CarTypeSelector isLoading={isLoading} isModal={isModal} filter={categoryListFilter} setFilters={setCategoryListFilter} />}
        </Flex>
    )
}

VehicleFilterBox.propTypes = {
    filters: PropTypes.shape({
        categoryList: PropTypes.array,
        vehicleType: PropTypes.string,
    }),
    setFilters: PropTypes.func,
    isLoading: PropTypes.bool,
    isModal: PropTypes.bool,
}

VehicleFilterBox.defaultProps = {
    isLoading: false,
    isModal: false,
}

export default VehicleFilterBox
